export default "__VITE_ASSET__BHnMRhzd__"